import { TableParams } from '../types';

export type GetJobsParams = TableParams & { [key: string]: string };

export type JobInfo = {
  id?: number;
  code: string;
  description: string;
  status: 'active' | 'inactive' | '';
};
export type JobModalType = 'EDIT' | 'ADD' | false | null;

export const JobModalTypes = {
  ADD: 'ADD',
  EDIT: 'EDIT',
};

export type DeleteJobPayload = {
  id: number;
};
